import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-bo-auth-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './bo-auth-input.component.html',
  styleUrls: ['./bo-auth-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthInputComponent {
  readonly inputId = input.required<string>();
  readonly label = input.required<string>();
  readonly placeholder = input('');
  readonly inputType = input('text');
  readonly autocomplete = input('off');
  readonly hasIcon = input(false);
  readonly hasSuffix = input(false);
  readonly customErrorMessage = input('Campo invalido');
  readonly control = input.required<FormControl>();
}
